import PropTypes from 'prop-types';
import React from 'react';

const Banderas = ({ Height, vPais }) => {
    if (!vPais) return null;

    // Usar las cadenas tal como vienen (UTF-8), sin normalización
    const key = vPais.trim();

    const flags = {
        'ARGENTINA': '/img/bandera-argentina-48.png',
        'BELIZE': '/img/bandera-belize-48.png',
        'BELICE': '/img/bandera-belize-48.png',
        'BOLIVIA': '/img/bandera-bolivia-48.png',
        'BRASIL': '/img/bandera-brasil-48.png',
        'CANADÁ': '/img/bandera-canada-48.png',
        'CHILE': '/img/bandera-chile-48.png',
        'COLOMBIA': '/img/bandera-colombia-48.png',
        'COSTA RICA': '/img/bandera-costa-rica-48.png',
        'CUBA': '/img/bandera-cuba-48.png',
        'REPUBLICA DOMINICANA': '/img/bandera-dominican-republic-48.png',
        'REPÚBLICA DOMINICANA': '/img/bandera-dominican-republic-48.png',
        'ECUADOR': '/img/bandera-ecuador-48.png',
        'EL SALVADOR': '/img/bandera-el-salvador-48.png',
        'GUATEMALA': '/img/bandera-guatemala-48.png',
        'GUYANA': '/img/bandera-guyana-48.png',
        'HONDURAS': '/img/bandera-honduras-48.png',
        'JAMAICA': '/img/bandera-jamaica-48.png',
        'MEXICO': '/img/bandera-mexico-48.png',
        'MÉXICO': '/img/bandera-mexico-48.png',
        'NICARAGUA': '/img/bandera-nicaragua-48.png',
        'PANAMA': '/img/bandera-panama-48.png',
        'PANAMÁ': '/img/bandera-panama-48.png',
        'PARAGUAY': '/img/bandera-paraguay-48.png',
        'PERU': '/img/bandera-peru-48.png',
        'PERÚ': '/img/bandera-peru-48.png',
        'PUERTO RICO': '/img/bandera-puerto-rico-48.png',
        'ESPANA': '/img/bandera-spain-48.png',
        'ESPAÑA': '/img/bandera-spain-48.png',
        'URUGUAY': '/img/bandera-uruguay-48.png',
        'ESTADOS UNIDOS': '/img/bandera-usa-48.png',
        'VENEZUELA': '/img/bandera-venezuela-48.png'
    };

    const src = flags[key] || null;

    return src ? <img src={src} title={vPais} alt={vPais} height={Height} className="mb-0" /> : null;
};

Banderas.propTypes = {
    vPais: PropTypes.string,
    Height: PropTypes.number
};

export default Banderas;
